<div class="page">
  <div class="container">

    <h1>Terms and Conditions</h1>

    <p>
      Welcome to DailyCity. By accessing and using this website, you agree
      to comply with the terms and conditions outlined on this page.
    </p>

    <h2>Use of Information</h2>
    <p>
      The information provided on DailyCity is for general informational
      purposes only. While we strive to keep the content accurate and up
      to date, we do not guarantee the completeness or reliability of any
      information published.
    </p>

    <h2>User Responsibility</h2>
    <p>
      Users are responsible for how they use the information available
      on this website. DailyCity shall not be held liable for any loss,
      damage, or inconvenience arising from the use of this website.
    </p>

    <h2>Third-Party Services</h2>
    <p>
      DailyCity may display advertisements and links from third-party
      services such as Google AdSense. We do not control or take
      responsibility for the content, privacy policies, or practices
      of third-party websites.
    </p>

    <h2>Changes to Terms</h2>
    <p>
      These terms and conditions may be updated or modified at any time
      without prior notice. Continued use of the website signifies your
      acceptance of any updated terms.
    </p>

    <h2>Contact</h2>
    <p>
      If you have any questions regarding these terms, you may contact us
      through the Contact Us page on DailyCity.
    </p>

  </div>
</div>
